import React from 'react';
import './VisitorInsights.css';

const VisitorInsights = ({ visitorData = [] }) => {
  // Group visitors by type
  const visitorGroups = visitorData.reduce((groups, visitor) => {
    const type = visitor.userType || 'anonymous';
    if (!groups[type]) groups[type] = [];
    groups[type].push(visitor);
    return groups;
  }, {});
  
  // Count visitors by authentication provider
  const authProviders = visitorData.reduce((providers, visitor) => {
    if (visitor.authProvider) {
      providers[visitor.authProvider] = (providers[visitor.authProvider] || 0) + 1;
    }
    return providers;
  }, {});
  
  return (
    <div className="visitor-insights">
      <h3>Visitor Insights</h3>
      
      <div className="visitor-stats">
        <div className="stat-card">
          <h4>Visitor Types</h4>
          <div className="stat-content">
            {Object.entries(visitorGroups).map(([type, visitors]) => (
              <div key={type} className="stat-item">
                <span className="stat-label">{type.charAt(0).toUpperCase() + type.slice(1)}</span>
                <span className="stat-value">{visitors.length}</span>
                <div className="stat-bar" style={{ width: `${(visitors.length / visitorData.length) * 100}%` }}></div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="stat-card">
          <h4>Authentication Sources</h4>
          <div className="stat-content">
            {Object.entries(authProviders).map(([provider, count]) => (
              <div key={provider} className="stat-item">
                <span className="stat-label">{provider.charAt(0).toUpperCase() + provider.slice(1)}</span>
                <span className="stat-value">{count}</span>
                <div className="stat-bar" style={{ width: `${(count / visitorData.length) * 100}%` }}></div>
              </div>
            ))}
            <div className="stat-item">
              <span className="stat-label">Anonymous</span>
              <span className="stat-value">
                {visitorData.length - Object.values(authProviders).reduce((sum, count) => sum + count, 0)}
              </span>
              <div className="stat-bar" style={{ 
                width: `${((visitorData.length - Object.values(authProviders).reduce((sum, count) => sum + count, 0)) / visitorData.length) * 100}%` 
              }}></div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="visitor-table-container">
        <h4>Top Identified Visitors</h4>
        <table className="visitor-table">
          <thead>
            <tr>
              <th>Visitor</th>
              <th>Source</th>
              <th>Type</th>
              <th>Pages Viewed</th>
              <th>Time on Site</th>
              <th>Last Seen</th>
            </tr>
          </thead>
          <tbody>
            {visitorData
              .filter(visitor => visitor.email || visitor.name || visitor.userId)
              .sort((a, b) => (b.pageViews || 0) - (a.pageViews || 0))
              .slice(0, 10)
              .map((visitor, index) => (
                <tr key={index}>
                  <td>{visitor.name || visitor.email || visitor.userId || 'Anonymous'}</td>
                  <td>{visitor.authProvider || (visitor.utmData?.source) || 'Direct'}</td>
                  <td>{visitor.userType || 'Unknown'}</td>
                  <td>{visitor.pageViews || 0}</td>
                  <td>{formatTime(visitor.timeOnSite || 0)}</td>
                  <td>{formatDate(visitor.lastUpdated)}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      
      <div className="visitor-privacy-notice">
        <p>
          <strong>Note:</strong> Ensure all visitor tracking complies with privacy regulations like GDPR and CCPA. 
          Always obtain proper consent before collecting personally identifiable information.
        </p>
      </div>
    </div>
  );
};

// Helper functions
const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}m ${remainingSeconds}s`;
};

const formatDate = (dateString) => {
  if (!dateString) return 'Unknown';
  const date = new Date(dateString);
  return date.toLocaleString();
};

export default VisitorInsights; 